import React from 'react';
import Card from '@material-ui/core/Card';
import styled from 'styled-components';
import Button from '@material-ui/core/Button';
import axios from "axios"; // 注意：这里导入了axios，但在代码示例中没有使用
import config from "../config.json"; // 同样，导入了config但没有在示例中使用

const EntryCard = styled(Card)`
  margin:10px;
`

const ReportButton = styled(Button)`
float:right;
width:160px;
`

const ReportTextDiv = styled.div`
  float:left;

  @media (max-width: 1340px)  {
    width:100%;
  }

  @media (min-width: 1340px)  {
    width: -webkit-calc(100% - 180px);
    width:    -moz-calc(100% - 180px);
    width:         calc(100% - 180px);
  }
`

const ReportDiv = styled.div`
  float:left;
  margin:10px;
`

class ReportBar extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    let { phase, disabled, handleSkip } = this.props; 
    var extra_media_skipper = null;

    if (phase === 2 || phase === 4) {
      extra_media_skipper = (
        <EntryCard>
          <ReportDiv data-tour="report">
            <ReportTextDiv>
              If the claim <b>directly refers</b> to an image, video, or audio clip, and <b>cannot be understood</b> without viewing or hearing it, the claim is a media claim that erroneously passed Phase One. In that case, please use this button to report the claim to use and skip it. Please be aware you cannot report a claim if you have already submitted an annotation for it.
            </ReportTextDiv>
            <ReportButton variant="contained" disabled={disabled} color="error" onClick={() => handleSkip("media")}>
              Report Media Claim
            </ReportButton>
          </ReportDiv>
        </EntryCard>
      );
    } else if (phase === 1) {
      extra_media_skipper = (
        <EntryCard>
          <ReportDiv data-tour="no-claim">
            <ReportTextDiv>
            If the fact-checking article does not address a specific claim from a speaker, but provide a general claim of itself or a collection of facts, we regard it as <b>no specific claim to be checked</b>. In that case, please use this button to report the claim and skip it. Please note that this is different from <b>REPORT & SKIP</b>, which refers to the situation where the fact checking article displays an error.
            </ReportTextDiv>
            <ReportButton variant="contained" disabled={disabled} color="error" onClick={() => handleSkip("no-claim")}>
              Report No Specific Claim
            </ReportButton>
          </ReportDiv>
        </EntryCard>
      );
    }

    return (
      <div>
        <EntryCard>
          <ReportDiv data-tour="report">
            <ReportTextDiv>
              If the fact checking article displays an error, is behind a paywall, or if it takes more than three minutes to load, please let us know and skip the claim. Please be aware you cannot report a claim if you have already submitted an annotation for it.
            </ReportTextDiv>

            <ReportButton variant="contained" disabled={disabled} color="error" onClick={() => handleSkip("other")}>
              Report & Skip
            </ReportButton>
          </ReportDiv>
        </EntryCard>
        {extra_media_skipper}
      </div>
    );
  }
}

export default ReportBar;